import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'reports.workorder',
  path: '/reports/workorder',
    title: 'Work Orders',
    component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);